/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import { Stack } from '@atlaskit/primitives/compiled';
import Textfield from '@atlaskit/textfield';

type Props = {
	label: string;
	name: string;
	id: string;
	isRequired: boolean;
};

export const TextInput = ({ label, name, id, isRequired }: Props): JSX.Element => (
	<Stack space="space.050">
		<Label htmlFor={id}>
			{label}
			{isRequired && <RequiredAsterisk />}
		</Label>
		<Textfield name={name} id={id} isRequired={isRequired} readOnly />
	</Stack>
);
